export default __webpack_public_path__ + "0a0b6df309febe5e8b6c74c066c6a08e.png";